import React from 'react';

const Maps = () => {
    return (
        <div className="dashboard-main">
            <div className="hero-panel">
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem' }}>🗺️ Karten</h2>
                    <p className="muted small">Interaktive Server-Karten</p>
                </div>
            </div>
            
            <div className="grid">
                <div className="card">
                    <div className="card-header">
                        <h4>Server-Karte</h4>
                    </div>
                    <div className="card-body">
                        <p className="muted">Hier wird eine interaktive Karte des Servers angezeigt.</p>
                        <div className="coming-soon">
                            <div className="coming-icon">🗺️</div>
                            <h3>Interaktive Karte</h3>
                            <p className="muted">Dieses Feature ist in Entwicklung und wird bald verfügbar sein.</p>
                        </div>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-header">
                        <h4>Karten-Features</h4>
                    </div>
                    <div className="card-body">
                        <div className="list">
                            <div className="list-item">
                                <div>
                                    <strong>Spieler-Positionen</strong>
                                    <p className="muted small">Live-Anzeige aller online Spieler</p>
                                </div>
                            </div>
                            <div className="list-item">
                                <div>
                                    <strong>Punktof-Interest</strong>
                                    <p className="muted small">Wichtige Orte und Gebäude</p>
                                </div>
                            </div>
                            <div className="list-item">
                                <div>
                                    <strong>Zoomen & Navigieren</strong>
                                    <p className="muted small">Vollständige Kartennavigation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Maps;
